import script from "./ErgebnisView.vue?vue&type=script&setup=true&lang=js"
export * from "./ErgebnisView.vue?vue&type=script&setup=true&lang=js"

import "./ErgebnisView.vue?vue&type=style&index=0&id=660730b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660730b0"]])

export default __exports__